import React, { useState } from "react";
import styles from "./LoginPage.module.css";
import { useLanguage } from "../../contexts/language/LanguageContext";
import { AiDmsLogo } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { loginWithPassword } from "../../services/auth";

const LoginPage = () => {
  const { t, switchLanguage, lang } = useLanguage();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      alert(t("login_alert_missing_fields"));
      return;
    }

    setIsSubmitting(true);
    try {
      await loginWithPassword({
        username: username.trim(),
        password,
      });
      navigate("/");
    } catch (error) {
      if (error?.status === 400 || error?.status === 401) {
        alert(t("login_alert_invalid_credentials"));
      } else {
        alert(error?.message || t("login_alert_failed"));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.loginBox}>
        {/* --- LANGUAGE SWITCHER --- */}
        <div className={styles.languageSwitcher}>
          <button
            className={`${styles.langBtn} ${lang === "vi" ? styles.activeLang : ""}`}
            onClick={() => switchLanguage("vi")}
          >
            VI
          </button>
          <span className={styles.divider}>|</span>
          <button
            className={`${styles.langBtn} ${lang === "en" ? styles.activeLang : ""}`}
            onClick={() => switchLanguage("en")}
          >
            EN
          </button>
        </div>

        {/* --- LOGO SECTION --- */}
        <div className={styles.logoWrapper}>
          <div className={styles.logoPlaceholder}>
            <img src={AiDmsLogo} alt="AI DMS Logo" />
          </div>
        </div>

        {/* --- HEADER SECTION --- */}
        <h2 className={styles.title}>{t("login_title")}</h2>
        <p className={styles.subtitle}>{t("login_subtitle")}</p>

        {/* --- FORM SECTION --- */}
        <form onSubmit={handleLogin} className={styles.form}>
          <div className={styles.inputGroup}>
            <label className={styles.label} htmlFor="username">
              {t("login_label_username")}
            </label>
            <input
              id="username"
              type="text"
              className={styles.input}
              placeholder={t("login_ph_username")}
              value={username}
              disabled={isSubmitting}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className={styles.inputGroup}>
            <label className={styles.label} htmlFor="password">
              {t("login_label_password")}
            </label>
            <input
              id="password"
              type="password"
              className={styles.input}
              placeholder={t("login_ph_password")}
              value={password}
              disabled={isSubmitting}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className={styles.button} disabled={isSubmitting}>
            {isSubmitting ? t("login_alert_process") : t("login_btn_submit")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
